/* eslint react-hooks/exhaustive-deps: "warn" */

import cn from 'classnames';

import styles from './PepsScreeningCard.module.scss';

import type { PepsScreeningCardProps } from './PepsScreeningCard.types';

type Chip = { label: string; variant: 'ok' | 'review' };

const ROWS: { initials: string; name: string; role: string; chips: Chip[] }[] = [
  {
    initials: 'JS',
    name: 'J. Smith',
    role: 'UBO · 75%',
    chips: [
      { label: '✓ Sanctions: no match', variant: 'ok' },
      { label: '✓ PEP: no match', variant: 'ok' },
    ],
  },
  {
    initials: 'RC',
    name: 'R. Chen',
    role: 'UBO · 25%',
    chips: [
      { label: '✓ Sanctions: no match', variant: 'ok' },
      { label: '! PEP: 1 potential match — review', variant: 'review' },
    ],
  },
  {
    initials: 'MP',
    name: 'M. Patel',
    role: 'Director · CFO',
    chips: [
      { label: '✓ Sanctions: no match', variant: 'ok' },
      { label: '✓ PEP: no match', variant: 'ok' },
    ],
  },
];

export const PepsScreeningCard = ({ className }: PepsScreeningCardProps) => (
  <div className={cn(styles.card, className)}>
    <div className={styles.head}>
      <span className={styles.ico}>🛡</span>
      <span className={styles.title}>PEPs &amp; Sanctions Screening</span>
      <span className={styles.pill}>3 people screened</span>
    </div>

    {ROWS.map((row) => (
      <div key={row.initials} className={styles.row}>
        <span className={styles.avatar}>{row.initials}</span>
        <div className={styles.rowBody}>
          <div className={styles.rowName}>
            {row.name} <span className={styles.rowRole}>{row.role}</span>
          </div>
          <div className={styles.chips}>
            {row.chips.map((chip) => (
              <span
                key={chip.label}
                className={cn(styles.chip, chip.variant === 'review' ? styles.chipReview : styles.chipOk)}
              >
                {chip.label}
              </span>
            ))}
          </div>
        </div>
      </div>
    ))}

    <div className={styles.source}>lists: OFAC · EU · UN · HMT · resolved to registry identity</div>
  </div>
);
